import { render } from "./SkeletonUpdateFeedCard.vue?vue&type=template&id=0aa4a0da"
import script from "./SkeletonUpdateFeedCard.vue?vue&type=script&lang=js"
export * from "./SkeletonUpdateFeedCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__